import React, { memo } from "react";
import { Button } from "@repo/core-ui";
import { Plus } from "lucide-react";

interface ChannelManagerHeaderProps {
  onRegisterNew: () => void;
}

export const ChannelManagerHeader: React.FC<ChannelManagerHeaderProps> = memo(
  ({ onRegisterNew }) => {
    return (
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 bg-white dark:bg-[#111c44] p-6 rounded-2xl shadow-sm border border-slate-200 dark:border-white/10">
        <div>
          <h1 className="text-2xl font-bold tracking-tight text-slate-800 dark:text-slate-100">
            Channel Matrix
          </h1>
          <p className="text-sm font-medium text-slate-500 dark:text-slate-400 mt-1">
            Manage your channel partners and OTA integrations
          </p>
        </div>

        <Button
          onClick={onRegisterNew}
          className="h-10 px-5 bg-blue-600 dark:bg-blue-500 hover:bg-blue-700 dark:hover:bg-blue-600 text-white rounded-xl text-sm font-bold transition-all flex items-center gap-2 shadow-sm"
        >
          <Plus size={18} className="stroke-[2.5px]" />
          Mint Channel
        </Button>
      </div>
    );
  },
);
ChannelManagerHeader.displayName = "ChannelManagerHeader";
